import React from 'react'
import { DashboardCard } from './OutstandingBalance'
import CardIconHeader from './Components/CardIconHeader'
import { useTheme } from '../../../middleware/ThemeContext'
import ContactRoleIcon from '../../../assets/icons/ContactRoleIcon'
import styled from 'styled-components'
import StyledText from '../../../components/StyledComponents/StyledText'
import TrendingUpIcon from '../../../assets/icons/TrendingUpIcon'
import { font } from '../../../utils/themes'
import UserInfo from './Components/UserInfo'
import ArrowIcon from '../../../assets/icons/ArrowIcon'
import DotIcon from '../../../assets/icons/DotIcon'
import { CardContainer } from '../../websiteBuilder/WebsiteConfiguration/SettingsComponents/CookieConsent'
import TooltipIcon from '../../../assets/icons/Tooltip'
import { Button } from '../../../components/form/Button'
import AlertNotice from './Components/AlertNotice'

const UserData = [
    {
        signedUrl: null,
        name: 'Benjamin Albert Strokes',
        subTitle: 'Due in 3 days'
    },
    {
        signedUrl: null,
        name: 'Benjamin Albert Strokes 2',
        subTitle: 'Due in 3 days'
    }
];

const FirstRenewals = () => {
    const {theme} = useTheme();
  return (
    <DashboardCard theme={theme}>
        <CardIconHeader 
            icon={<ContactRoleIcon size={24} Color={theme.CorporateTheme.colors.blueberry} /> }
            title='First Renewals'
            count="18"
            iconBgColor='rgba(5, 86, 203, 0.1)'
            tooltipText='This list is based on a prebuilt query showing members who joined recently and are now due for their first renewal.'
            viewIcon={true}
        />
        <hr />
        <RelationRate 
            theme={theme}
            style={{ 
                backgroundColor: theme.CorporateTheme.colors.bgLightGreen,
                borderColor: theme.CorporateTheme.colors.green
             }}
        >
            <div className='d-flex align-items-center gap-1'>
                <TrendingUpIcon color={theme.CorporateTheme.colors.green} />
                <StyledText
                    fontSize='14px'
                    fontWeight={700}
                    textColor={theme.CorporateTheme.colors.green}
                >
                    <span style={{ fontFamily: font.lato }}>82</span>% Retention Rate
                </StyledText>
            </div>
            <StyledText
                fontSize='14px'
                fontWeight={600}
                textColor={theme.CorporateTheme.colors.gunmetal}
            >
                +<span style={{ fontFamily: font.lato }}>4</span>% vs LY
            </StyledText>
        </RelationRate>
        
        <div className='my-4'>
            {UserData.map((data, index) => (
                <div className='d-flex align-items-center justify-content-between mb-4' key={index}>
                    <div className='d-flex align-items-center gap-2'>
                        <DotIcon color={theme.CorporateTheme.colors.green} />
                        <UserInfo
                            image={data.signedUrl ? data.signedUrl : ''}
                            name={data.name}
                            subTitle={data.subTitle}
                        />
                    </div>
                    <ArrowIcon 
                        rotate='right'
                    />
                </div>
            ))}
        </div>

        <AlertNotice 
            message='First-year members are 40% more likely to churn. Consider a personal outreach.'
        />

        <Button
            theme={theme}
            $variant='customButton'
            textColor={theme.CorporateTheme.colors.primary}
            color={theme.CorporateTheme.colors.primary}
            fontSize='12px'
            fontWeight='600'
            borderColor={theme.CorporateTheme.colors.filterBG}
            width='100%'
            textPosition='start'
        >
            View all First Renewals
            <ArrowIcon rotate='right' color={theme.CorporateTheme.colors.gunmetal} />
        </Button>
    </DashboardCard>
  )
}

const RelationRate = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid;
    border-radius: 5px;
    padding: 10px 15px;
`;

export default FirstRenewals